module.exports = __webpack_public_path__ + "img/KZ.fb346a50.png";